import http from '../../http-common';

export const toFechaISO = (fecha) => {
    if (!fecha) return null;
    if (typeof fecha === 'string') {
        const match = fecha.match(/(\d{4}-\d{2}-\d{2})/);
        return match ? match[1] : null;
    }
    const d = new Date(fecha);
    if (Number.isNaN(d.getTime())) return null;
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${mm}-${dd}`;
};

// El backend hoy solo filtra por idMovimientosBancarios; el filtro por cuenta se hace aquí.
// Registros viejos sin idCuentaBancaria se aceptan como respaldo para no romper datos previos.
export const buscarControlIngreso = async (idMovimientosBancarios, idCuentaBancaria) => {
    const resp = await http.get('/control-ingresos/busca-movimiento', {
        params: { idCuentaBancaria, idMovimientosBancarios },
        validateStatus: () => true,
    });
    if (!resp || resp.status < 200 || resp.status >= 300 || !resp.data) return null;
    const registros = (Array.isArray(resp.data) ? resp.data : [resp.data]).filter((r) => r && r.id);
    const mismaCuenta = registros.find((r) => String(r.idCuentaBancaria) === String(idCuentaBancaria));
    if (mismaCuenta) return mismaCuenta;
    return registros.find((r) => r.idCuentaBancaria == null) || null;
};
